import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import SearchBar from "../ui/SearchBar";

interface RequestsToolbarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: () => void;
  isLoading: boolean;
  onRefresh: () => void;
  children?: React.ReactNode;
}

export const RequestsToolbar: React.FC<RequestsToolbarProps> = ({
  searchQuery,
  onSearchChange,
  onSearchSubmit,
  isLoading,
  onRefresh,
  children,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      {/* Refresh + Search: take full row on small, share row on larger */}
      <div className="flex items-center gap-2 flex-[1_1_100%] xsm:flex-[1_1_auto] xsm:min-w-[260px]">
        <button
          onClick={onRefresh}
          disabled={isLoading}
          className="p-2 rounded-md border border-gray-200 hover:bg-gray-100 disabled:opacity-50 dark:border-gray-800 dark:hover:bg-gray-700"
          aria-label="Refresh"
        >
          <ArrowPathIcon className="w-5 h-5 text-gray-600 dark:text-gray-300" />
        </button>
        <div className="flex-1">
          <SearchBar
            searchQuery={searchQuery}
            onSearchChange={onSearchChange}
            onSearchSubmit={onSearchSubmit}
            isLoading={isLoading}
            placeholder="Search requests..."
          />
        </div>
      </div>

      {/* Right side: filters, sort, favorites; full row on small, wraps as needed */}
      <div className="flex flex-wrap items-center gap-2 flex-[1_1_100%] xsm:flex-[0_0_auto]">
        {children}
      </div>
    </div>
  );
};

